import { render } from "./WSCalc.vue?vue&type=template&id=daef217e&scoped=true"
import script from "./WSCalc.vue?vue&type=script&lang=js"
export * from "./WSCalc.vue?vue&type=script&lang=js"

import "./WSCalc.vue?vue&type=style&index=0&id=daef217e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daef217e"]])

export default __exports__